export const MODULE_VIEW_EVENT_OPTIONS = {
  actionlocation: 'value-props-module'
};
